
import { Options } from "vue-class-component";
import { List, Search, Tab, Tabs, Popup, Icon } from "vant";
import BaseList from "@/common/BaseList";

import AppUtil from "@/util/AppUtil";
import WxUtil from "@/util/WxUtil";
import UserVo from "@/vo/UserVo";
import TenantVo from "@/vo/TenantVo";
@Options({
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [List.name]: List,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Search.name]: Search,
  },
})
/**畅享卡首页 */
export default class ShopList extends BaseList {
  reqUrl = "/zhShareStore/store/getStoreList";

  tabArr: { id: number }[] = [];
  tabIdx = 0;
  finished = true;
  _title = "畅享卡";
  user = UserVo.getInstance();
  mounted() {
    if (!this.user.id) {
      this.user.req_data()
    }
    AppUtil.request(
      {
        url: "/zhShareStore/store/getStoreSortList",
        method: "post",
      },
      this.get_sorts,
      "正在加载分类信息"
    );
    this.set_share();
  }
  private to_home(){
    this.$router.push({
      name: 'Home'
    })
  }
  /**设置分享内容 */
  private set_share() {
    WxUtil.initWx = false;
    WxUtil.get_wx().then(wx => {
      let tenantVo = TenantVo.getInstance();
      let link = "https://" + window.location.host + "/#/enioyCard/shops?appid=" + localStorage.getItem("appid") + "&tenantId=" + localStorage.getItem('tenantId');
      console.log('link', link);

      wx.onMenuShareTimeline({
        title: this.title, // 分享标题
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: tenantVo.thumb, // 分享图标
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('onMenuShareTimeline');
        }
      })

      wx.onMenuShareAppMessage({
        title: this.title, // 分享标题

        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: tenantVo.thumb, // 分享图标
        success: function () {
          console.log('onMenuShareAppMessage');
          // 用户点击了分享后执行的回调函数
        }
      })
      wx.updateTimelineShareData({
        title: this.title, // 分享标题
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: tenantVo.thumb, // 分享图标
        success: function () {
          // 设置成功
          console.log('updateTimelineShareData');
        }
      })
      wx.updateAppMessageShareData({
        title: this.title, // 分享标题

        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: tenantVo.thumb, // 分享图标
        success: function () {
          console.log('updateAppMessageShareData');

          // 设置成功
        }
      })
    });
  }

  get_sorts(res: any) {
    console.log("商家分类", res);
    this.tabArr = [{ sortName: '全部', id: "" }, ...res.data];
    this.tab_change(0);
  }
  /**列表提示 */
  public get finishedTxt() {
    if (this.loading) {
      return "加载中...";
    }
    if (this.list.length) {
      return "没有更多了";
    }
    return "查无商家";
  }
  get cardImg() {
    if (this.user.isCxcard) {
      return require("@/assets/card-use.png");
    }
    return require("@/assets/card-buy.png");
  }
  card_click() {
    let arr = ["BuyEnioyCard", "CardUser"]
    this.$router.push({
      name: arr[this.user.isCxcard]
    })

  }
  private tab_change(index: number) {
    // console.log("index", index);
    // // console.log("tabIdx",this.config.tabIdx)
    this.reqData.sortId = this.tabArr[index].id;
    this.reqData.page = 0;
    this.list = [];
    this.loading = true;
    this.req_items();
  }
  // private req_orderList() {}
  protected init_item(val: any) {
    val.thumb = AppUtil.get_thumb(val.storeLogo);
    return val;
  }
  tel_click(tel: string) {
    window.location.href = "tel:" + tel;
  }
  private map_click(item: any) {
    WxUtil.get_wx().then((wx) => {
      wx.openLocation({
        latitude: parseFloat(item.latitude.toString()), // 纬度，浮点数，范围为90 ~ -90
        longitude: parseFloat(item.longitude.toString()),

        name: item.storeName, // 位置名
        address: item.addressDetail, // 地址详情说明
        scale: 14, // 地图缩放级别,整型值,范围从1~28。默认为最大
        infoUrl: "", // 在查看位置界面底部显示的超链接,可点击跳转
      });
    });
  }
}
